import authentication from './authentication'

const bankId = {
    authentication: Object.assign(authentication, authentication),
}

export default bankId